import { REFETCH_DATA } from 'constants.js'
import { buildAction } from 'store/actions/actionCreator'

export const refetchData = buildAction(REFETCH_DATA)
